import { ActionIcon, Group, Tooltip } from '@mantine/core';
import React from 'react';
import { Trans } from 'react-i18next';

import { SvgThumbDown, SvgThumbDownFilled, SvgThumbUp, SvgThumbUpFilled } from '@mygpt/app/chat/components/icon';
import { feedbackType } from '@mygpt/app/chat/services';

interface ReviewButtonProps {
  active: feedbackType | '';
  onReview?: (reviewType: feedbackType) => void; // 回调函数，用于打开模态框并记录被点击的按钮
}

interface ButtonsItem {
  type: feedbackType;
  title: React.ReactNode;
  icon: () => JSX.Element;
  actionIcon: () => JSX.Element;
}

const Buttons: ButtonsItem[] = [
  {
    type: 'good',
    title: <Trans i18nKey={'completions.thumb_up'} />,
    icon: SvgThumbUp,
    actionIcon: SvgThumbUpFilled,
  },
  {
    type: 'bad',
    title: <Trans i18nKey={'completions.thumb_down'} />,
    icon: SvgThumbDown,
    actionIcon: SvgThumbDownFilled,
  },
];

const ReviewButton: React.FC<ReviewButtonProps> = ({ active, onReview }) => {
  return (
    <Group gap={5} wrap="nowrap">
      {Buttons.map((item, index) => {
        const Icon = item.icon;
        const ActiveIcon = item.actionIcon;
        return (
          <Tooltip key={index} label={item.title} withArrow multiline w={240} position="bottom">
            <ActionIcon
              disabled={!!active}
              variant={active ? 'transparent' : 'subtle'}
              color="indigo"
              onClick={() => {
                onReview && onReview(item.type);
              }}
            >
              {active === item.type ? (
                <ActiveIcon />
              ) : (
                <span className="hover:text-gray-600 text-gray-500">
                  <Icon />
                </span>
              )}
            </ActionIcon>
          </Tooltip>
        );
      })}
    </Group>
  );
};

export default ReviewButton;
